export function getEditableSchemaProperty(schema) {
    return {
        name: schema.getNameSignature(),
        type: schema.getTypeSignature(),
        description: schema.description
    };
}
//# sourceMappingURL=EditableSchemaProperty.js.map